import {styled, theme} from "@reside/ui";

export const FilterPillTrigger = styled.button<{$active: boolean}>`
  align-items: center;
  background: ${({$active}) =>
    $active ? theme.color.primary : theme.color.white};
  border: 1px solid
    ${({$active}) => ($active ? theme.color.primary : theme.color.darkBlue100)};
  border-radius: 999px;
  cursor: pointer;
  display: inline-flex;
  flex-shrink: 0;
  font-family: Gilroy, sans-serif;
  gap: 8px;
  height: 32px;
  padding: 0 14px;
`;

export const FilterPillLabel = styled.span<{$active: boolean}>`
  color: ${({$active}) =>
    $active ? theme.color.white : theme.color.darkBlue100};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
`;

export const FilterPillBadge = styled.span`
  align-items: center;
  background: ${theme.color.white};
  border-radius: 999px;
  color: ${theme.color.primary};
  display: inline-flex;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  height: 18px;
  justify-content: center;
  line-height: 1;
  min-width: 18px;
  padding: 0 4px;
`;

export const FilterPillChevron = styled.span`
  align-items: center;
  display: inline-flex;
  flex-shrink: 0;
  line-height: 0;
`;

export const PermissionsManagementFilterSelectorWrapper = styled.div`
  ul {
    overflow-y: auto;
  }

  .rc-tree .permissions-management-filter-group > span {
    display: none;
  }

  .rc-tree .permissions-management-filter-group > [role="group"] {
    padding-left: 0;
  }

  .rc-tree > li + li {
    border-top: none;
  }
`;
